(function() {
    'use strict';

    // TODO @SES@ Name should not be capitalized

    fileNameValidationService.$inject = [
        'invalidFileExtensions'
    ];

    function fileNameValidationService(invalidFileExtensions) {

        var lowercaseInvalidFileExtensions = undefined;

        var service = {
            getInvalidExtensions: getInvalidExtensions,
            isValid: isValid
        };

        initialize();

        return service;

        function initialize() {
            if (lowercaseInvalidFileExtensions === undefined) {
                lowercaseInvalidFileExtensions = getLowercaseArray(invalidFileExtensions);
            }
        }

        function getLowercaseArray(array) {
            var result = [];

            for (var i = 0; i < array.length; i++) {
                result.push(array[i].toLowerCase());
            }

            return result;
        }

        function isValid(fileName) {

            var fileNameParts = fileName.split('.');

            if (fileNameParts.length > 1) {
                var extension = fileNameParts[fileNameParts.length - 1].toLowerCase();
                if (lowercaseInvalidFileExtensions.indexOf(extension) >= 0) {
                    return false;
                }
            }

            return true;
        }

        function getInvalidExtensions() {
            return lowercaseInvalidFileExtensions;
        }
    }

    module.exports = fileNameValidationService;
})();